<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.sa_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="sa_vendname">
            <label class="weui-form-preview__label">{{customLabel.sa_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.sa_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="sa_man">
            <label class="weui-form-preview__label">{{customLabel.sa_man || "联系人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >
              {{ form.main.sa_man }}
              {{ form.main.sa_tel }}
              <call-mobile :mobile="form.main.sa_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sa_reason">
            <label class="weui-form-preview__label">{{customLabel.sa_reason || "打样原因"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >
              {{ form.main.sa_reason }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sa_address">
            <label class="weui-form-preview__label">{{customLabel.sa_address || "交货地址"}}</label>
            <span
              class="weui-form-preview__value"
              :class="{
                'weui-form-preview__value-icon': !!form.main.sa_address,
              }"
              >{{ form.main.sa_address }}
              <router-link
                v-if="form.main.sa_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.sa_address"
              ></router-link>
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sad_inoutno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="sad_prodname">
              <label class="weui-form-preview__label">{{customLabel.sad_prodname || "物料名称"}}</label>
              <span class="weui-form-preview__value">
                {{ item.sad_prodcode }}
                {{ item.sad_prodname }}
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.sad_orispeccode" slot="sad_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.sad_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">
                {{ item.sad_orispeccode }}
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.sad_spec" slot="sad_spec">
              <label class="weui-form-preview__label">{{customLabel.sad_spec || "规格"}}</label>
              <span class="weui-form-preview__value">
                {{ item.sad_spec }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sad_qty">
              <label class="weui-form-preview__label">{{customLabel.sad_qty || "数量"}}</label>
              <span class="weui-form-preview__value">
                {{ item.sad_qty }}
                {{ item.sad_unit }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sad_brand">
              <label class="weui-form-preview__label">{{customLabel.sad_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">
                {{ item.sad_brand }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sad_date">
              <label class="weui-form-preview__label">{{customLabel.sad_date || "需求日期"}}</label>
              <span class="weui-form-preview__value">
                {{ dateFormat(item.sad_date,'yyyy-MM-dd') }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/sample/samples",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "Purchase",
      xtype: "sample-sampleBase-formpanel",
    };
  },
};
</script>